<template>
    <PRICE_VAT_TIP :showVATTip="showVATTip" :currentCountry="currentCountry" />
</template>
<script>
import { get } from 'lodash';
import { mapGetters } from "vuex";

export default {
  name: 'priceVATTip',
  computed: {
    ...mapGetters([
      'soldToContact',
    ]),
    currentCountry () {
      return get(this.soldToContact, 'country') || get(window.newBillingConfig, 'currentCountry', '')
    }
  },
  watch: {
    'soldToContact.country': {
      immediate: true,
      deep: true,
      handler () {
        this.currentCountry && this.$updateShowVATTip?.(this.currentCountry);
      },
    }
  }
};
</script>
<style lang="scss">
.opc-cart__total__text__sub {
  .VAT-tip + * {
    display: none;
  }
}
</style>

